import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full min-h-full bg-ink font-sans antialiased" data-id="element-0" data-mp="23vcmh01cjofb">
      <MetaPixel data-id="element-1" data-mp="23t8heerpojdg" />
      <main data-id="element-2" data-mp="3ijxpcqos80jw">
        <Hero data-id="element-3" data-mp="3ik7eyd5x05p2" />
        <BeforeAfter data-id="element-4" data-mp="3ikr0s4yore8d" />
        <PainPoints data-id="element-5" data-mp="3ij65ue8glt9z" />
        <Volumes data-id="element-6" data-mp="3ijpef4c7z5bc" />
        <Bonuses data-id="element-7" data-mp="3ii4ppvcl6gle" />
        <Offer data-id="element-8" data-mp="3mlatmwc87vop" />
        <Guarantee data-id="element-9" data-mp="3mkrcviybbdc9" />
        <Testimonials data-id="element-10" data-mp="3mk83wrqn3zad" />
        <About data-id="element-11" data-mp="3mjg8bgx1m1k3" />
        <Faq data-id="element-12" data-mp="3rc9du70c5dx8" />
        <FinalCta data-id="element-13" data-mp="3rcj31sdk3h1v" />
      </main>
      <Footer data-id="element-14" data-mp="3rdkhm6ts6loc" />
      <PurchasePopup data-id="element-15" data-mp="3rcsulke91w9o" />
      <FloatingCTA data-id="element-16" data-mp="3relumgucxi8p" />
    </div>;
}